import { tv } from 'tailwind-variants';

import type { StackAlign, StackJustify, StackSpacing } from './Stack.types';

export const stack = tv({
	base: 'flex',
	variants: {
		direction: {
			row: 'flex-row',
			column: 'flex-col',
		},
		align: {
			start: 'items-start',
			center: 'items-center',
			end: 'items-end',
			stretch: 'items-stretch',
			baseline: 'items-baseline',
		} satisfies Record<StackAlign, string>,
		justify: {
			start: 'justify-start',
			center: 'justify-center',
			end: 'justify-end',
			between: 'justify-between',
			around: 'justify-around',
			evenly: 'justify-evenly',
		} satisfies Record<StackJustify, string>,
		spacing: {
			none: '',
			extraTight: 'gap-1',
			tight: 'gap-2',
			loose: 'gap-4',
			mediumLoose: 'gap-6',
			extraLoose: 'gap-8',
		} satisfies Record<StackSpacing, string>,
		wrap: {
			true: 'flex-wrap',
		},
	},
	defaultVariants: {
		spacing: 'none',
	},
});
